import Icon from '../../components/Icon.vue'

Icon.register({"brands/vimeo":{"width":448,"height":512,"paths":[{"d":"M403.2 32H44.8C20.1 32 0 52.1 0 76.8V435.2C0 459.9 20.1 480 44.8 480H403.2C427.9 480 448 459.9 448 435.2V76.8C448 52.1 427.9 32 403.2 32zM377 180.8C375.6 212.3 353.6 255.5 311 310.2 267 367.4 229.7 396 199.3 396 180.4 396 164.5 378.6 151.4 343.7 125.9 250.4 115 195.7 94 195.7 91.6 195.7 83.1 200.8 68.6 210.9L53.4 191.3C90.7 158.5 126.3 122.1 148.6 120.1 173.8 117.7 189.3 134.9 195.1 171.8 215.8 303 225 322.8 262.7 263.4 276.2 242 283.5 225.7 284.5 214.5 288 181.3 258.6 183.6 238.7 192.1 254.6 140 285 114.7 329.9 116.1 363.2 117 378.9 138.6 377 180.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/vimeo.js
// module id = null
// module chunks = 